import { assert } from '@Utils/assert';

import MessageBroker from '@Services/MessageBroker';
import RequestUrls from '@Constants/RequestUrlsConstants';

// eslint-disable-next-line import/prefer-default-export
export async function getSupplierInfo(params) {
  assert(params.databaseId, 'databaseId required parameter');
  assert(params.crn, 'crn required parameter');

  const result = await MessageBroker.send(RequestUrls.rcsSupplierInfo, params);

  return result;
}
